import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../../Service";
import DataClient from "../../../../../../Service/general_data_service";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomSelect from "../../../../../../Components/CustomSelect";
import CustomInput from "../../../../../../Components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    // width: "600px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "none",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    "& button": {
      marginRight: "20px",
    },
  },
  autoComplete: {},
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageCoachRateCard(props) {
  const classes = useStyles();
  const {
    action,
    handleClose,
    handleClose1,
    externalSelection,
    internalSelection,
    status,
    setInternalExternalLoader,
  } = props;

  // const [popupValue, setPopupValue] = useState(externalSelection.id ? 'external' : 'internal');
  const [popupValue, setPopupValue] = useState(status || "external");

  // const message = useContext(ToastMessageContext);
  const global_data_common = useSelector((state) => state.commonReducer);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [feildValue, setFeildValue] = useState([]);
  // const [internalJobTitlesArr, setInternalJobTitlesArr] = useState([]);
  const [currenciesArr, setCurrenciesArr] = useState([]);
  const [value, setValue] = React.useState("");
  const [value1, setValue1] = React.useState("");
  const [levelData, setLevelData] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const dispatch = useDispatch();
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);

  const dataObject = {
    level: "",
    service_type: "",
  };
  const [userData, setUserData] = useState({});
  const [userData1, setUserData1] = useState({});
  const [inputValue, setInputValue] = React.useState(userData?.service);

  useEffect(() => {
    props.ExternalCoaching();
    props.InternalCoaching();
    setUserData(externalSelection);
    setUserData1(internalSelection);
  }, [props.regionId, externalSelection, internalSelection]);

  useEffect(() => {
    DataService.getDirectData(
      `/rate_cards/fetch_services_and_levels?available_region_id=${props?.regionId}&rate_card_type=${popupValue}`
    ).then((response) => {
      setLevelData(response?.levels);
      setServiceType(response?.services);
    });
  }, [popupValue]);

  const handleCreate = (formData) => {
    var flag = true;
    if (value === "") {
      flag = false;
    }

    if (flag) {
      setSubmitClickFlag(true);
      setLoading(true);
      DataService.createData(
        { available_region_id: props.regionId, ...userData, service: value },
        "coaching_rate_cards_external"
      )
        .then((res) => {
          if (res) {
            props.ExternalCoaching();
            props.setRefresh(!props.refresh);
            handleClose(res.data);
            dispatch(
              showSnackbar("success", [
                "External Coaching Rate Card Added Successfully!",
              ])
            );
          } else {
            // message.showToastMessage({ open: true, message: res.errors ?
            // res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
            setLoading(false);
          }
        })
        .catch(() => {
          // message.showToastMessage({ open: true, message: "Something went wrong. Try
          // Again", variant: "error" });
          setLoading(false);
        });
    }
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const onChangeItem1 = (selectedItemValue, inputId) => {
    setUserData1({
      ...userData1,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const handleUpdate = (formData) => {
    setLoading(true);
    const statusData = {
      available_region_id: props.regionId,
      external_rate_card_id: externalSelection.id,
      ...userData,
      service: value,
    };

    DataClient.update(statusData, `/rate_cards/update_external_rate_card`)
      .then((res) => {
        if (res.data) {
          props.ExternalCoaching();
          props.setRefresh(!props.refresh);
          handleClose(res.data);
          dispatch(
            showSnackbar("success", [
              "External Coaching Rate Card Updated Successfully!",
            ])
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const handleDelete = () => {
    setInternalExternalLoader((old) => ({ ...old, external: true }));
    DataClient.remove(
      `/rate_cards/delete_external_rate_card?available_region_id=${props.regionId}&external_rate_card_id=${externalSelection.id}`
    )
      .then((res) => {
        if (res.success) {
          props.ExternalCoaching();
          props.setRefresh(!props.refresh);
          handleClose(null, externalSelection.id);
          dispatch(
            showSnackbar("success", [
              "External Coaching Rate Card Deleted Successfully!",
            ])
          );
          setInternalExternalLoader((old) => ({ ...old, external: false }));
        }
      })
      .catch(() => {
        setLoading(false);
        setInternalExternalLoader((old) => ({ ...old, internal: false }));
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      // console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
    } else if (action === "edit") {
      handleUpdate(formData);
    } else {
      handleDelete();
    }
  };
  const handleDelete1 = () => {
    setInternalExternalLoader((old) => ({ ...old, internal: true }));
    handleClose1(null, internalSelection.id);
    DataClient.remove(
      `/rate_cards/delete_internal_rate_card?available_region_id=${props.regionId}&internal_rate_card_id=${internalSelection.id}`
    )
      .then((res) => {
        if (res.success) {
          setTimeout(() => {
            props.InternalCoaching();
            props.setRefresh(!props.refresh);
            handleClose1(null, internalSelection.id);
            dispatch(
              showSnackbar("success", [
                "Internal Coaching Rate Card Deleted Successfully!",
              ])
            );
            setInternalExternalLoader((old) => ({ ...old, internal: false }));
          }, 300);
        }
      })
      .catch(() => {
        setLoading(false);
        setInternalExternalLoader((old) => ({ ...old, internal: false }));
      });
  };

  const handleCreate1 = (formData) => {
    setLoading(true);
    DataService.createData(
      { available_region_id: props.regionId, ...userData1, service: value1 },
      "coaching_rate_cards_internal"
    )
      .then((res) => {
        if (res.data) {
          props.InternalCoaching();
          props.setRefresh(!props.refresh);
          handleClose1(res.data);
          dispatch(
            showSnackbar("success", [
              "Internal Coaching Rate Card Added Successfully!",
            ])
          );
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleUpdate1 = (formData) => {
    const statusData = {
      available_region_id: props.regionId,
      internal_rate_card_id: internalSelection.id,
      ...userData1,
      service: value1,
    };

    DataClient.update(statusData, `/rate_cards/update_internal_rate_card`)
      .then((res) => {
        if (res?.data) {
          props.InternalCoaching();
          props.setRefresh(!props.refresh);
          handleClose1(res.data);
          dispatch(
            showSnackbar("success", [
              "Internal Coaching Rate Card Updated Successfully!",
            ])
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const setInputState1 = (inputStateValue, inputId) => {
    setUserData1({ ...userData1, [inputId]: inputStateValue });
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    if (action === "create") {
      handleCreate1(formData);
    } else if (action === "edit1") {
      handleUpdate1(formData);
    } else {
      handleDelete1();
    }
  };

  return (
    <div>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        onClose={handleClose}
        open={true}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle style={{}} id="customized-dialog-title">
          <Typography variant="subtitle1">
            {action === "edit" || action === "edit"
              ? `Edit  rate - ${props.regionName}`
              : ""}
            {action === "create" ? `Adding new rate - ${props.regionName}` : ""}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent
          style={{
            margin: "0px auto",
          }}
        >
          <RadioGroup
            row
            aria-label="position"
            name="rate_type"
            value={popupValue}
            onChange={(e) => setPopupValue(e.target.value)}
          >
            <FormControlLabel
              value="external"
              control={<Radio color="primary" />}
              label={<Typography variant="h2">External</Typography>}
              labelPlacement="end"
              disabled={action !== "create" ? true : false}
            />
            <FormControlLabel
              value="internal"
              control={<Radio color="primary" />}
              label={<Typography variant="h2">Internal</Typography>}
              labelPlacement="end"
              disabled={action !== "create" ? true : false}
            />
          </RadioGroup>
          {action !== "delete" && action !== "delete1" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="subtitle1"
                className={classes.title}
              ></Typography>
              <form
                onSubmit={
                  popupValue === "external" ? handleSubmit : handleSubmit1
                }
              >
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                >
                  {popupValue === "external" && (
                    <React.Fragment>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Service type
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Autocomplete
                          value={value || userData?.service}
                          onChange={(event, newValue) => {
                            if (newValue === null) {
                              newValue = "";
                            }
                            setValue(newValue);
                          }}
                          classes={{
                            input: classes.autoComplete,
                            option: classes.autoComplete,
                          }}
                          defaultValue={userData?.service}
                          id="controllable-states-demo"
                          options={serviceType}
                          getOptionLabel={(option) => option}
                          // style={{ width: 250 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search service type"
                              variant="outlined"
                              required
                              autoFocus
                              InputLabelProps={{
                                style: {
                                  fontSize: "16px",
                                  fontFamily: "Open Sans",
                                },
                              }}
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  fontSize: "16px",
                                  fontFamily: "Open Sans",
                                  padding: "0px",
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Level
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          id="level"
                          name={"level"}
                          targetId={"level"}
                          labelText="Select level"
                          displayEmpty
                          variant="outlined"
                          defaultValue={userData?.level}
                          itemArr={levelData}
                          parentcall={onChangeItem}
                          required
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Label
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="label"
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={externalSelection.label}
                          placeholder="Label"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Program price{" "}
                          {externalSelection?.currency
                            ? `(${externalSelection?.currency})`
                            : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="programme_price"
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={externalSelection.programme_price}
                          placeholder="Program price"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Hrs for program
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="programme_hours"
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={externalSelection.programme_hours}
                          placeholder="Program hours"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Session rate{" "}
                          {externalSelection?.currency
                            ? `(${externalSelection?.currency})`
                            : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="session_rate"
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={externalSelection.session_rate}
                          placeholder="Session rate"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          variant="h2"

                          // className={classes.title}
                        >
                          No of hrs in a session
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="num_of_hours_in_a_session"
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={
                            externalSelection.num_of_hours_in_a_session
                          }
                          placeholder="No of hrs in a session"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Hourly rate{" "}
                          {externalSelection?.currency
                            ? `(${externalSelection?.currency})`
                            : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="hourly_rate"
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={externalSelection.hourly_rate}
                          placeholder="Hourly rate"
                        />
                      </Grid>

                      <Grid item xs={2}>
                        <Typography variant="h2" className={classes.title}>
                          Exceptional comments if any
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          id="comments"
                          defaultValue={externalSelection.comments}
                          multiline={true}
                          rows={4}
                          parentcall={setInputState}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          placeholder="Comments"
                        />
                      </Grid>
                    </React.Fragment>
                  )}
                  {popupValue === "internal" && (
                    <React.Fragment>
                      <Grid item xs={4}>
                        <Typography variant="h2" className={classes.title}>
                          Service type
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Autocomplete
                          value={value1 || userData1?.service}
                          onChange={(event, newValue) => {
                            if (newValue === null) {
                              newValue = "";
                            }
                            setValue1(newValue);
                          }}
                          classes={{
                            input: classes.autoComplete,
                            option: classes.autoComplete,
                          }}
                          defaultValue={userData1?.service}
                          id="controllable-states-demo"
                          options={serviceType}
                          getOptionLabel={(option) => option}
                          // style={{ width: 250 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search service type"
                              variant="outlined"
                              required
                              InputLabelProps={{
                                style: {
                                  fontSize: "16px",
                                  fontFamily: "Open Sans",
                                },
                              }}
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  fontSize: "16px",
                                  fontFamily: "Open Sans",
                                  padding: "0px",
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h2" className={classes.title}>
                          Level
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <CustomSelect
                          targetId="level"
                          name="level"
                          id="level"
                          labelText="Select level"
                          displayEmpty
                          variant="outlined"
                          defaultValue={userData1.level}
                          itemArr={levelData}
                          parentcall={onChangeItem1}
                          //required
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h2" className={classes.title}>
                          Label
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <CustomInput
                          id="label"
                          parentcall={setInputState1}
                          defaultValue={internalSelection.label}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          placeholder="Label"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h2" className={classes.title}>
                          Program admin price{" "}
                          {internalSelection?.currency
                            ? `(${internalSelection?.currency})`
                            : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <CustomInput
                          defaultValue={internalSelection.programme_admin_price}
                          id="programme_admin_price"
                          parentcall={setInputState1}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          placeholder="Program admin price"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h2" className={classes.title}>
                          No of sessions
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <CustomInput
                          id="number_of_sessions"
                          defaultValue={internalSelection.number_of_sessions}
                          parentcall={setInputState1}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          placeholder="No of sessions"
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <Typography variant="h2" className={classes.title}>
                          Exceptional comments if any
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <CustomInput
                          id="comments"
                          multiline={true}
                          rows={4}
                          defaultValue={internalSelection.comments}
                          parentcall={setInputState1}
                          //required
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          placeholder="Comments"
                        />
                      </Grid>
                    </React.Fragment>
                  )}
                </Grid>

                <div className={classes.actionButtons}>
                  <Button
                    disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    disableElevation
                    disabled={loading}
                    type="submit"
                    variant={"contained"}
                    color="primary"
                  >
                    {action === "create" ? "Add" : "Update"}
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            <div className={classes.formWrapper}>
              {action === "delete1"
                ? "Warning, deleting this internal Coaching rate card will delete the items from the ordering list. Are you sure?"
                : "Warning, deleting this  External Coaching rate card will delete  the items from the ordering list. Are you sure?"}
              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={
                    popupValue === "external" ? handleClose : handleClose1
                  }
                >
                  Cancel
                </Button>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  color="primary"
                  onClick={action === "delete1" ? handleDelete1 : handleDelete}
                >
                  Yes, Confirm
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
      )
    </div>
  );
}

export default ManageCoachRateCard;
